import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/**
 * ForbiddenPage — 403 fallback rendered by RoleGuard when the user
 * is authenticated but lacks the role(s) required for a route.
 *
 * Same minimalist layout as NotFoundPage, just a different status
 * code and copy. Kept distinct so future support can ship a deep
 * link with screenshots without conflating "missing" and "denied".
 */
export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4 text-center">
      <p className="text-6xl font-bold text-primary" aria-hidden>
        403
      </p>
      <h1 className="text-2xl font-semibold">{t('errors.forbidden.title')}</h1>
      <p className="max-w-md text-muted-foreground">
        {t('errors.forbidden.description')}
      </p>
      <Button asChild>
        <Link to="/dashboard">{t('common.backToDashboard')}</Link>
      </Button>
    </main>
  );
}
